import React, { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { useSetState, useDebounce } from '@campaignhub/react-hooks'

import PageContext from '@contexts/pageContext'

import useClientsV4 from '@hooks/useClientsV4'

import InfiniteLinkingTags from '@components/InfiniteLinkingTags'

const defaultState = {
  reset: false,
  searchFilter: '',
}

const ClientLinking = (props) => {
  const { callbacks, linkedClients, zoneForm } = props

  const { loadingLinkedClients } = useContext(PageContext)

  const [state, setState] = useSetState(defaultState)
  const { reset, searchFilter } = state

  const { toggleUpdateLinkedClients } = callbacks

  const {
    entityState: {
      name,
      reference,
    },
  } = zoneForm

  const debouncedSearchFilter = useDebounce(searchFilter, 300)

  const { filteredClientsV4, loading, hasMore, callbacks: { loadNextPage, loadInitialPage } } = useClientsV4({ searchFilter: debouncedSearchFilter })

  useEffect(() => {
    loadInitialPage()
  }, [debouncedSearchFilter])

  const toggleClient = async (client, type) => {
    const updatedClient = { ...client, zone: { entity: reference || '' } }
    let newList = []

    if (type === 'add'){
      if (client?.zone_detail && client?.zone?.entity){
        newList = await swal.fire({
          title: 'Move Client to this Zone',
          html: `This action will move this client from ${client.zone_detail?.name} to ${name || 'this zone'}.`
          + '<br/>Do you wish to proceed?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#e2001a',
        }).then(({ value }) => {
          if (value){
            return [...linkedClients, updatedClient]
          }
          return linkedClients
        })
      } else {
        newList = [...linkedClients, updatedClient]
      }
    } else {
      newList = linkedClients.filter(x => x.id !== client.id)
    }

    toggleUpdateLinkedClients(newList)
  }

  return (
    <InfiniteLinkingTags
      label="Clients"
      secondLabel={`(${linkedClients.length})`}
      options={filteredClientsV4}
      selectedItems={linkedClients}
      onSelect={item => toggleClient(item, 'add')}
      onRemove={item => toggleClient(item)}
      onLoadMore={loadNextPage}
      hasMore={hasMore}
      loading={loading}
      loadingLinkedItems={loadingLinkedClients}
      placeholder="Search Clients"
      labelKey="name"
      subLabelKey="zone_detail.name"
      valueKey="id"
      searchFilter={searchFilter}
      onSearchChange={val => setState({ searchFilter: val })}
    />
  )
}

ClientLinking.propTypes = {
  callbacks: PropTypes.object,
  linkedClients: PropTypes.array,
  zoneForm: PropTypes.object,
}

export default ClientLinking
